'use client';

import { JssProvider, SheetsRegistry, createGenerateId } from 'react-jss';
import { useServerInsertedHTML } from 'next/navigation';
import { useState } from 'react';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

const JssRegistryProvider = ({ children }: Props) => {
  const [registry] = useState(() => new SheetsRegistry());
  const [generateId] = useState(() => createGenerateId());

  // Called once per streamed chunk: flush only the styles added since the last chunk
  useServerInsertedHTML(() => {
    const styles = registry.toString();
    registry.reset();
    if (!styles) return null;
    return <style data-jss-server-side="" type="text/css" dangerouslySetInnerHTML={{ __html: styles }} />;
  });

  return (
    <JssProvider registry={registry} generateId={generateId}>
      {children}
    </JssProvider>
  );
};

export default JssRegistryProvider;
